export const VISUAL_DIAGRAM_NODE_TYPE = "visual-diagram-node";
export function isVisualDiagramNode(what) {
    return what.type.includes(VISUAL_DIAGRAM_NODE_TYPE);
}
//# sourceMappingURL=visual-diagram-node.js.map